import { render, staticRenderFns } from "./StartlistGroupMenuComponent.vue?vue&type=template&id=fce8bbf2&scoped=true"
import script from "./StartlistGroupMenuComponent.vue?vue&type=script&lang=ts"
export * from "./StartlistGroupMenuComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce8bbf2",
  null
  
)

export default component.exports